import axios from 'axios'
import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'
const ID_COLLECTION_ITEM_FINDER = 'js-collectionItemFinder'

document.addEventListener('DOMContentLoaded', async () => {
  const elementItemFinder = document.getElementById(ID_COLLECTION_ITEM_FINDER)
  if (!elementItemFinder) return

  const dataset = elementItemFinder.dataset
  const showCount = parseInt(dataset.showCount, 10) || 30
  const collectionId = `gid://shopify/Collection/${dataset.collectionId}`
  const storefrontAccessToken = dataset.storefrontAccessToken

  if (!storefrontAccessToken) return

  const fetchProducts = async () => {
    const { data } = await axios.post(
      '/api/unstable/graphql.json',
      {
        query: `
        {
          collection(id: "${collectionId}") {
            handle
            products(first: 250) {
              edges {
                node {
                  availableForSale
                  featuredImage {
                    url
                  }
                  handle
                  imageItemFinder: metafield(namespace: "item_finder", key: "image") {
                    reference {
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                    }
                  }
                  tags
                  title
                }
              }
            }
          }
        }`,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
      }
    )
    return data.data.collection.products.edges
      .filter(
        (edge) =>
          edge.node.availableForSale &&
          !edge.node.tags.includes('algolia-ignore') &&
          !edge.node.tags.includes('out_of_stock') // SOLD OUT または 入荷待ち
      )
      .map((edge) => {
        const image =
          edge.node.imageItemFinder?.reference?.image?.url ||
          edge.node.featuredImage?.url
        const href = `/products/${edge.node.handle}`

        return {
          title: edge.node.title,
          image,
          href,
        }
      })
  }

  const shuffleProducts = (products) => {
    return products.sort(() => Math.random() - 0.5)
  }

  const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  createApp({
    name: 'TemplatesCollectionItemFinder',
    data() {
      return {
        products: null,
        isDesktop: isDesktop(),
        productsToShow: [],
        hasError: false,
        isLoading: true,
        isShow: new Array(showCount).fill(false),
      }
    },
    async mounted() {
      setTimeout(async () => {
        try {
          this.products = await fetchProducts()
          this.setProducts()
        } catch (error) {
          this.hasError = true
        } finally {
          this.isLoading = false
          document.querySelectorAll('.js-placeholder').forEach((el) => {
            el.remove()
          })
        }
      }, 500)
    },
    methods: {
      async setProducts() {
        if (this.products) {
          this.productsToShow = shuffleProducts(this.products).slice(
            0,
            showCount
          )
          this.isShow.fill(false)
          this.$refs.container.scrollIntoView({
            behavior: 'smooth',
          })

          for (let i = 0; i < showCount; i++) {
            await delay(100)
            this.isShow.splice(i, 1, true)
          }
        } else {
          this.productsToShow = new Array(showCount).fill(false)
        }
      },
      async retry() {
        this.productsToShow = new Array(showCount).fill(false)
        this.hasError = false
        this.isLoading = true
        try {
          this.products = await fetchProducts()
          this.setProducts()
        } catch (error) {
          this.productsToShow = []
          this.hasError = true
        } finally {
          this.isLoading = false
        }
      },
    },
  }).mount(elementItemFinder)
})
